/**
 * Local cache for a user's project list. Lives in localStorage alongside
 * optional cloud state so the user can:
 *   - keep a list of recently-opened projects between sessions
 *   - make changes offline-ish (the editor itself still hits the API)
 *   - "Save" (sync) the local project set to the cloud via the Save button
 */
const KEY = 'superflow.projects.v1';
export function loadCache() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    }
    catch {
        return [];
    }
}
export function saveCache(projects) {
    try {
        localStorage.setItem(KEY, JSON.stringify(projects));
    }
    catch {
        // quota exceeded — ignore, the source of truth is the server
    }
}
export function upsertProject(p) {
    const list = loadCache();
    const idx = list.findIndex((x) => x.id === p.id);
    if (idx === -1)
        list.unshift(p);
    else
        list[idx] = { ...list[idx], ...p };
    saveCache(list);
}
export function removeProject(id) {
    saveCache(loadCache().filter((p) => p.id !== id));
}
export function markDirty(dirty) {
    try {
        localStorage.setItem('superflow.dirty', dirty ? '1' : '0');
    }
    catch {
        // ignore
    }
}
export function isDirty() {
    try {
        return localStorage.getItem('superflow.dirty') === '1';
    }
    catch {
        return false;
    }
}
